var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:("portfolioCategory" + (_vm.item.num)),staticClass:"portfolioCategory",style:({background :
     (_vm.activeState ?
      ("url(//" + (_vm.item.savedUrl) + "portfolio/active/" + (_vm.item.portfolioActiveImage) + ") 0% 0% / contain no-repeat ")
       : ("url(//" + (_vm.item.savedUrl) + "portfolio/" + (_vm.item.portfolioImage) + ") 0% 0% / contain no-repeat ") ),
  }),on:{"mouseenter":function($event){_vm.handleCategoryMouseEnter(_vm.item.num)},"mouseleave":function($event){_vm.handleCategoryMouseLeave(_vm.item.num)},"click":function($event){_vm.handleCategoryClick(_vm.item.num)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a4088aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/Portfolio/Category.vue
// module id = null
// module chunks = 